/* Leaves Lighting — slide-out cart drawer backed by the real Shopify AJAX cart. */
(function () {
  var FREE = 30000; // free-shipping threshold in cents ($300)
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function $(id) { return document.getElementById(id); }

  function open() { document.body.classList.add('cart-open'); refresh(); }
  function close() { document.body.classList.remove('cart-open'); }

  async function getCart() { var r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); return r.json(); }

  function render(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; e.style.display = cart.item_count > 0 ? '' : 'none'; });
    var items = $('lv-cart-items'); if (!items) return;
    var foot = $('lv-cart-foot'); var ship = $('lv-cart-ship');
    if (cart.item_count === 0) {
      items.innerHTML = '<div style="padding:56px 0;text-align:center;"><p style="margin:0 0 20px;color:var(--color-neutral-dark);">Your build is waiting.</p><a href="/pages/configure" class="btn btn-bulb">build your kit</a></div>';
      if (foot) foot.style.display = 'none';
      if (ship) ship.style.display = 'none';
      return;
    }
    items.innerHTML = cart.items.map(function (i) {
      var variant = (i.variant_title && i.variant_title.indexOf('Default') === -1) ? '<p class="text-small" style="color:var(--color-neutral-dark);margin-top:2px;">' + i.variant_title + '</p>' : '';
      var img = i.image ? '<img src="' + i.image + '" alt="" style="width:100%;height:100%;object-fit:contain;display:block;">' : '';
      return '<div style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid var(--color-neutral-darkest-15);">' +
        '<div style="width:64px;height:64px;flex:0 0 auto;background:var(--color-white);overflow:hidden;">' + img + '</div>' +
        '<div style="flex:1;min-width:0;">' +
          '<div style="display:flex;justify-content:space-between;gap:8px;">' +
            '<span style="font-weight:600;font-size:var(--text-regular);">' + i.product_title + '</span>' +
            '<button data-cart-remove="' + i.key + '" aria-label="Remove" style="background:none;border:0;padding:0;cursor:pointer;color:var(--color-neutral);flex:0 0 auto;"><i data-lucide="trash-2" style="width:16px;height:16px"></i></button>' +
          '</div>' + variant +
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;">' +
            '<span style="display:inline-flex;align-items:center;border:1px solid var(--color-neutral-darkest-15);background:var(--color-white);">' +
              '<button data-cart-set="' + i.key + '|' + (i.quantity - 1) + '" aria-label="Decrease" style="background:none;border:0;padding:6px 11px;cursor:pointer;line-height:1;">−</button>' +
              '<span style="min-width:28px;text-align:center;font-weight:600;">' + i.quantity + '</span>' +
              '<button data-cart-set="' + i.key + '|' + (i.quantity + 1) + '" aria-label="Increase" style="background:none;border:0;padding:6px 11px;cursor:pointer;line-height:1;">+</button>' +
            '</span>' +
            '<span style="font-weight:600;font-variant-numeric:tabular-nums;">' + money(i.final_line_price) + '</span>' +
          '</div>' +
        '</div></div>';
    }).join('');
    if (foot) { foot.style.display = ''; $('lv-cart-subtotal').textContent = money(cart.total_price); }
    if (ship) {
      ship.style.display = '';
      ship.querySelector('[data-ship-msg]').innerHTML = '<span style="color:var(--color-forest);font-weight:600;">Free standard shipping on every order</span>';
      var bar = ship.querySelector('[data-ship-bar]'); if (bar && bar.parentElement) bar.parentElement.style.display = 'none';
    }
    if (window.lucide) lucide.createIcons();
  }

  async function refresh() { try { render(await getCart()); } catch (e) {} }
  async function setQty(key, qty) { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }); refresh(); }

  // Public: add a variant and open the drawer.
  window.lvCartAdd = async function (variantId, qty) {
    try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }) }); } catch (e) {}
    open();
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if ((e.target.closest && e.target.closest('[data-cart-close]')) || (e.target.classList && e.target.classList.contains('lv-cart-backdrop'))) { close(); return; }
    var rm = e.target.closest && e.target.closest('[data-cart-remove]'); if (rm) { setQty(rm.getAttribute('data-cart-remove'), 0); return; }
    var st = e.target.closest && e.target.closest('[data-cart-set]'); if (st) { var p = st.getAttribute('data-cart-set').split('|'); setQty(p[0], Math.max(0, parseInt(p[1], 10))); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('leaves:cart-open', open);
  if (document.readyState !== 'loading') refresh(); else document.addEventListener('DOMContentLoaded', refresh);
})();
